import { render, staticRenderFns } from "./ProjectTypeDisplay.vue?vue&type=template&id=24e675c1&scoped=true&"
import script from "./ProjectTypeDisplay.vue?vue&type=script&lang=ts&"
export * from "./ProjectTypeDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTypeDisplay.vue?vue&type=style&index=0&id=24e675c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e675c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
